module.exports = __webpack_public_path__ + "static/hobgoblin-01a29d0784e01464fefa7002ee2e3327.jpg";